const SportClassesBanners = [
    {
        id: 1,
        label: "fitness",
        title: "بدنسازی",
        img: "/images/bodyBuilding.svg"
    },
    {
        id: 2,
        label: "pilates",
        title: "پیلاتس",
        img: "/images/pilates.svg"
    },
    {
        id: 3,
        label: "yoga",
        title: "یوگا",
        img: "/images/yoga.svg"
    }
]

export default SportClassesBanners;